import { Button, FormGroup, Input, Label, Select } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { areaCd } from '@/constants/areaCd'
import { bizGubn } from '@/constants/bizGubn'
import { ntnCd } from '@/constants/ntnCd'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import commonUtils from '@/utils/commonUtils'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Col, Row } from 'styled-bootstrap-grid'

interface GetRequest {
  bizCd?: string //업체코드
  seq: number
}

interface BizDetailItem {
  cmpnyCd: string
  bizCd: string
  bizNm: string
  bizGubn: string
  ntnCd: string
  areaCd: string
  baseDomain: string
  chrgeDomain: string
  addr: string
  phone: string
  email: string
  useYn: string
  mshipYn: string
  batchYn: string
  manualYn: string
  userName: string
  uri: string
  rem: string
  schrTag: string
  cstRem: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  seq: number
  newBatchYn: string
  holeType: string
  confidenceLvlCd: string
}

const DetailBizHistMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { showConfirm } = useDialog()
  const [requestData] = useState({
    bizCd: String(location.state?.bizCd),
    seq: location.state?.seq,
  })

  const [bizHistDetailMap, setbizHistDetailMap] =
    useState<BizDetailItem | null>(null)

  const { getComCodeValue, getComCodes } = useRedis()

  useEffect(() => {
    getBizHistDetail()
  }, [])

  //업체이력상세조회
  const getBizHistDetail = async () => {
    try {
      const data: GetRequest = {
        bizCd: requestData.bizCd,
        seq: requestData.seq,
      }

      const response = await axios.get('/bizMgmt/detailHist', {
        params: { ...data },
      })

      const bizHistDetailMap = response.data
      setbizHistDetailMap(bizHistDetailMap)
    } catch (err: any) {
      console.error('Error fetching detailHist:', err)
    }
  }

  return (
    <>
      <div
        style={{
          width: '100%',
          height: '100%',
          marginTop: '50px',
          margin: '0 auto',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ fontSize: '20px' }}>업체이력상세</p>
          <FlexWrapper gap="10px">
            <Button
              onClick={() => {
                showConfirm({
                  title: `업체등록/수정 화면으로 이동할까요?`,
                  onConfirm() {
                    navigate(-1)
                  },
                })
              }}
              color="neverbe"
              variant="outlined"
            >
              돌아가기
            </Button>
          </FlexWrapper>
        </div>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizCd">
                업체코드
              </Label>
              <Input
                id="bizCd"
                name="bizCd"
                type="text"
                placeholder="업체코드는 자동 생성됩니다."
                maxLength={20}
                value={bizHistDetailMap?.bizCd || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizNm">
                업체명
              </Label>
              <Input
                id="bizNm"
                name="bizNm"
                type="text"
                placeholder="업체명을 입력해주세요."
                maxLength={100}
                value={bizHistDetailMap?.bizNm || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="bizGubn">
                업체구분
              </Label>
              <Select
                id="bizGubn"
                name="bizGubn"
                value={bizHistDetailMap?.bizGubn || ''}
                disabled={true}
              >
                {bizGubn.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="holeType">
                홀 유형
              </Label>
              <Select
                id="holeType"
                name="holeType"
                value={bizHistDetailMap?.holeType || ''}
                disabled={true}
              >
                <option value="">선택</option>
                {getComCodes('HOLE_TYPE').map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="ntnCd">
                국가코드
              </Label>
              <Select
                id="ntnCd"
                name="ntnCd"
                value={bizHistDetailMap?.ntnCd}
                disabled={true}
              >
                {ntnCd.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="areaCd">
                지역코드
              </Label>
              <Select
                id="areaCd"
                name="areaCd"
                value={bizHistDetailMap?.areaCd || ''}
                disabled={true}
              >
                {areaCd.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="baseDomain">
                기본도메인
              </Label>
              <Input
                id="baseDomain"
                name="baseDomain"
                type="text"
                placeholder="기본도메인을 입력해주세요."
                maxLength={200}
                value={bizHistDetailMap?.baseDomain || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="chrgeDomain">
                가격도메인
              </Label>
              <Input
                id="chrgeDomain"
                name="chrgeDomain"
                type="text"
                placeholder="가격도메인을 입력해주세요."
                maxLength={1000}
                value={bizHistDetailMap?.chrgeDomain || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="addr">
                주소
              </Label>
              <Input
                id="addr"
                name="addr"
                type="text"
                placeholder="주소를 입력해주세요."
                maxLength={200}
                value={bizHistDetailMap?.addr || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="email">
                이메일
              </Label>
              <Input
                id="email"
                name="email"
                type="text"
                placeholder="이메일을 입력해주세요."
                maxLength={100}
                value={bizHistDetailMap?.email || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="phone">
                전화번호
              </Label>
              <Input
                id="phone"
                name="phone"
                type="text"
                placeholder="전화번호를 입력해주세요."
                maxLength={20}
                value={bizHistDetailMap?.phone || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                사용여부
              </Label>
              <Select
                id="useYn"
                name="useYn"
                value={bizHistDetailMap?.useYn || ''}
                disabled={true}
              >
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="mshipYn">
                회원제여부
              </Label>
              <Select
                id="mshipYn"
                name="mshipYn"
                value={bizHistDetailMap?.mshipYn || ''}
                disabled={true}
              >
                {getComCodes('MSHIP_YN').map((item) => (
                  <option key={'mshipYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          {/* <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="batchYn">
                배치여부
              </Label>
              <Select
                id="batchYn"
                name="batchYn"
                value={bizHistDetailMap?.batchYn || ''}
                disabled={true}
              >
                <option value="">선택</option>
                <option value="Y">배치</option>
                <option value="N">수기관리</option>
              </Select>
            </FormGroup>
          </Col> */}
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="newBatchYn">
                배치여부
              </Label>
              <Select
                id="newBatchYn"
                name="newBatchYn"
                value={bizHistDetailMap?.newBatchYn || ''}
                disabled={true}
              >
                {getComCodes('NEW_BATCH_YN').map((item) => (
                  <option key={'newBatchYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="manualYn">
                수기관리여부
              </Label>
              <Select
                id="manualYn"
                name="manualYn"
                value={bizHistDetailMap?.manualYn || ''}
                disabled={true}
              >
                {getComCodes('MANUAL_YN').map((item) => (
                  <option key={'manualYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="confidenceLvlCd">
                정확도
              </Label>
              <Select
                id="confidenceLvlCd"
                name="confidenceLvlCd"
                value={bizHistDetailMap?.confidenceLvlCd || ''}
                disabled={true}
              >
                {getComCodes('CONFIDENCE_LVL_CD').map((item) => (
                  <option key={'confidenceLvlCd' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="uri">
                URI
              </Label>
              <Input
                id="uri"
                name="uri"
                type="text"
                placeholder="URI를 입력해주세요."
                maxLength={200}
                value={bizHistDetailMap?.uri || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="rem">
                비고
              </Label>
              <Input
                id="rem"
                name="rem"
                type="text"
                placeholder="비고를 입력해주세요."
                maxLength={200}
                value={bizHistDetailMap?.rem || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="rem">
                비고
              </Label>
              <Input
                id="cstRem"
                name="cstRem"
                type="text"
                placeholder="고객용비고를 입력해주세요."
                maxLength={200}
                value={bizHistDetailMap?.cstRem || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="schrTag">
                검색어태그
              </Label>
              <Input
                id="schrTag"
                name="schrTag"
                type="text"
                placeholder="검색어태그를 입력해주세요."
                maxLength={200}
                value={bizHistDetailMap?.schrTag || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                등록자
              </Label>
              <Input
                id="regId"
                name="regId"
                type="text"
                maxLength={200}
                value={bizHistDetailMap?.regId || ''}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regDate">
                등록일시
              </Label>
              <Input
                id="regDate"
                name="regDate"
                type="text"
                maxLength={200}
                value={commonUtils.formatDate(
                  bizHistDetailMap?.regDate || '',
                  true,
                )}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updId">
                수정자
              </Label>
              <Input
                id="updId"
                name="updId"
                type="text"
                maxLength={200}
                value={
                  `${bizHistDetailMap?.userName} (${bizHistDetailMap?.updId})` ||
                  ''
                }
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updDate">
                수정일시
              </Label>
              <Input
                id="updDate"
                name="updDate"
                type="text"
                maxLength={200}
                value={commonUtils.formatDate(
                  bizHistDetailMap?.updDate || '',
                  true,
                )}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default DetailBizHistMgmt
